var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 19,
    fill: "#2DFBB5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5593 14.2978L16.2074 14.3331C16.3349 14.34 16.4476 14.4187 16.4978 14.5362L17.4419 16.7425C17.4924 16.8604 17.4712 16.9967 17.3872 17.0937L16.5655 18.0432C16.4989 18.1203 16.4872 18.2299 16.5342 18.3202C17.6164 20.4026 19.5888 21.2278 20.1776 21.4345C20.278 21.4697 20.3892 21.4364 20.4541 21.3523L21.3139 20.2389C21.4096 20.1151 21.5782 20.0737 21.7203 20.1391L23.9105 21.1476C24.0532 21.2133 24.1312 21.369 24.0983 21.5224L23.9948 22.0051C23.8781 22.5498 23.5543 23.0316 23.0845 23.3318C22.4914 23.7108 21.7226 23.8969 20.7453 23.6209C17.7126 22.7642 15.9975 20.7585 15.0772 19.505C14.1569 18.2514 13.8014 16.9978 14.0315 15.9741C14.1857 15.2875 14.6881 14.7606 15.0023 14.4881C15.1561 14.3546 15.3558 14.2867 15.5593 14.2978Z",
    fill: "#292929"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 29L10.4007 24.0306C9.49996 22.5021 9.02573 20.7629 9.02573 18.9763C9.02573 13.4754 13.5059 9 19.0129 9C24.5198 9 29 13.4754 29 18.9763C29 24.4773 24.5198 28.9527 19.0129 28.9527C17.297 28.9527 15.6167 28.5139 14.1303 27.6808L9 29ZM14.3926 25.8658L14.6983 26.0523C15.9943 26.8426 17.4863 27.2604 19.0129 27.2604C23.5857 27.2604 27.3058 23.5442 27.3058 18.9763C27.3058 14.4085 23.5857 10.6923 19.0129 10.6923C14.4401 10.6923 10.7199 14.4085 10.7199 18.9763C10.7199 20.5679 11.1727 22.1135 12.0293 23.446L12.2352 23.7662L11.4286 26.628L14.3926 25.8658Z",
    fill: "#292929"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.e963a9a4354d37ac1e3890ba19c2931e.svg";
export { ForwardRef as ReactComponent };